// extracted by mini-css-extract-plugin
export default {"user_notice":"MessageIcon_user_notice__IQY6j","user_notice_num":"MessageIcon_user_notice_num__UtFz2"};